import React from 'react';
import PropTypes from 'prop-types';

const TableCheckbox = ({ id, checked, onChange, disabled, indeterminate, ariaLabel }) => {
  const checkboxRef = React.useRef(null);

  React.useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <input
      ref={checkboxRef}
      id={id}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      aria-label={ariaLabel}
      style={{
        width: '16px',
        height: '16px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        margin: 0,
        padding: 0,
      }}
    />
  );
};

TableCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

TableCheckbox.defaultProps = {
  checked: false,
  onChange: () => {},
  disabled: false,
  indeterminate: false,
  ariaLabel: '',
};

export default TableCheckbox;